/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc isg
 */
import { IsgBaseInfoController } from './baseinfo';
import { RetaincapitalController } from './retaincapital';
import { VisitingcardController } from './visitingcard';

export class IsgController {
  /** @dec 留资跟踪 */
  RetaincapitalController = new RetaincapitalController();
  /** @dec 名片 */
  VisitingcardController = new VisitingcardController();
  /** @dec 基本信息 */
  IsgBaseInfoController = new IsgBaseInfoController();
}
